import { ItemTypeConsts } from 'client/util/Constants';
import SystemItemTableColumns from 'client/systems/SystemItemTable/SystemItemTableColumns';
import SystemUserItemTableColumns from 'client/systemusers/SystemUserItemTable/SystemUserItemTableColumns';

export default {
  [ItemTypeConsts.systemUser]: SystemUserItemTableColumns,
  [ItemTypeConsts.device]: SystemItemTableColumns,
};
